import axios from '@axios'
import axiosRu from '@axios-ru'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTracks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/track', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchArtists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/artist', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchArtists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/artist/search', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchArtistDetails(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}`, {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createArtist(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSimilarArtists(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/similar`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    ignoreTracks(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/ignore-missing`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTrack(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/track/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    additionalTracks(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/additional-tracks`, {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchTracksByName(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/search-tracks`, {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    flushCache(ctx, {id}) {
      return Promise.all([
        axios.post(`/artist/${id}/flush-cache`),
        axiosRu.post(`/artist/${id}/flush-cache`),
      ]).then(([response, responseRu]) => {
        const deleted = (response.data.deleted || 0) + (responseRu.data.deleted || 0)
        return { data: { deleted } }
      })
    },
    loadLastfmInfo(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/load-lastfm-info`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    syncArtistSpotify(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/sync-spotify`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    syncArtistYandex(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/artist/${id}/sync-yandex`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    syncArtistShs(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/sync-shs`, queryParams || {})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    syncArtistWikipedia(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/sync-wikipedia`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    syncArtistShsTracks(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/sync-shs-tracks`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchArtistShsTracks(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/shs-tracks`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    linkShsTrack(ctx, {id, shs_id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/track/${id}/link-shs`, {shs_id})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchArtistAliases(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/aliases`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addAlias(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/add-alias`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateArtist(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/artist/${id}`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addTrack(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/add-track`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createTrackWithoutArtist(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/track', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateTrack(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/track/${id}`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addTrackExternalId(ctx, {id, url}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/track/${id}/external-id`, {url})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addArtistExternalId(ctx, {id, url}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/external-id`, {url})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArtistExternalId(ctx, {id, source}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/artist/${id}/external-id/${source}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTrackExternalId(ctx, {id, source}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/track/${id}/external-id/${source}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTrackShsCovers(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/track/${id}/shs-covers`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTrackCovers(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/track/${id}/covers`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchTracksInDb(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/track/search', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    findTrackOriginal(ctx, {query}) {
      return new Promise((resolve, reject) => {
        axios
          .get('/track/find-original', {params: {query}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    setTrackOriginal(ctx, {id, original_id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/track/${id}/set-original`, {original_id})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addTrackCover(ctx, {id, cover_id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/track/${id}/add-cover`, {cover_track_id: cover_id})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeTrackOriginal(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/track/${id}/remove-original`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeTrackCover(ctx, {id, cover_id}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/track/${id}/remove-cover/${cover_id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTrackDetails(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/track/${id}/details`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchTrack(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        const instance = queryParams && queryParams.source === 'youtube' ? axios : axiosRu
        instance
          .get(`/track/${id}/search`, {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateYoutubeCookies(ctx, {cookies}) {
      return new Promise((resolve, reject) => {
        axios
          .post('/track/youtube-cookies', {cookies})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadTrack(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/track/${id}/download`, {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchArtistAlbums(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/search-albums`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchArtistYandexAlbums(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/artist/${id}/search-yandex-albums`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAlbumTracks(ctx, {id, source, albumId}) {
      const client = source === 'yandex' ? axiosRu : axios
      return new Promise((resolve, reject) => {
        client
          .get(`/artist/${id}/album-tracks`, {params: {source, album_id: albumId}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSpotifyNewReleases(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/releases/spotify')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchYandexNewReleases(ctx) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/releases/yandex')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReleasesAlbumTracks(ctx, {source, albumId}) {
      const client = source === 'yandex' ? axiosRu : axios
      return new Promise((resolve, reject) => {
        client
          .get('/releases/album-tracks', {params: {source, album_id: albumId}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchArtistCovers(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/covers`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    saveArtistCover(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/save-cover`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArtistCover(ctx, {id, coverId}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/artist/${id}/delete-cover/${coverId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateArtistCover(ctx, {id, coverId, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/artist/${id}/covers/${coverId}`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchArtistPhotos(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/photos`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchArtistPhotos(ctx, {id, start, query}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/artist/${id}/search-photos`, {params: {start, query}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    saveArtistPhoto(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/save-photo`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateArtistPhoto(ctx, {id, photoId, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/artist/${id}/photos/${photoId}`, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArtistPhoto(ctx, {id, photoId}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/artist/${id}/delete-photo/${photoId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadTrackMp3(ctx, {id, file}) {
      const formData = new FormData()
      formData.append('file', file)
      return new Promise((resolve, reject) => {
        axios
          .post(`/track/${id}/upload-mp3`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    clearYoutubeCache(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/track/${id}/clear-youtube-cache`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadTrackYoutube(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/track/${id}/download`, {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    yandexPlaylistSearch(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
            .get('/yandex/playlist-search', {params: queryParams})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    yandexPlaylistSave(ctx, {id, owner_id, queryParams}) {
      return new Promise((resolve, reject) => {
        axiosRu
            .post(`/yandex/playlist/save/${owner_id}/${id}`, {params: queryParams})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    yandexPlaylistView(ctx, {id, owner_id, queryParams}) {
      return new Promise((resolve, reject) => {
        axiosRu
            .get(`/yandex/playlist/${owner_id}/${id}`, {params: queryParams})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    spotifyPlaylistSearch(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
            .get('/spotify/playlist-search', {params: queryParams})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    spotifyPlaylistView(ctx, {id, queryParams}) {
      return new Promise((resolve, reject) => {
        axios
            .get(`/spotify/playlist/${id}`, {params: queryParams})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    sigameImportList(ctx, {file, id}) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        let params = []
        if (file) {
          formData.append('file', file);
        }
        if (id) {
          formData.append('id', id);
        }
        axios
            .post('/sigame/import-list', formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  },
                  params: params,
                }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    kworbImport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        let params = []
        axios
            .get(`/kworb/chart`,{params: queryParams})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    fetchMissingTracks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
            .get('/track/missing', {params: queryParams})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    coverImport(ctx, payload) {
      return new Promise((resolve, reject) => {
        const ruSources = ['yandex', 'vk']
        const instance = ruSources.includes(payload.source) ? axiosRu : axios
        instance
          .post('/cover-import', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sigameAnalyze(ctx, {file}) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        if (file) {
          formData.append('file', file);
        }
        axios
            .post('/sigame/analyze', formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  },
                }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    packFromFiles(ctx, { file, options, onProgress }) {
      const formData = new FormData()
      formData.append('archive', file)
      Object.keys(options || {}).forEach(key => {
        const value = options[key]
        if (value !== null && value !== undefined && value !== '') {
          formData.append(key, value)
        }
      })

      const token = localStorage.getItem('accessToken')
      const baseURL = (axios.defaults.baseURL || '').replace(/\/$/, '')

      return fetch(`${baseURL}/sigame/pack-from-files`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      }).then(async response => {
        if (!response.ok || !response.body) {
          throw new Error('Ошибка запроса: ' + response.status)
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''
        let result = null

        // eslint-disable-next-line no-constant-condition
        while (true) {
          // eslint-disable-next-line no-await-in-loop
          const { done, value } = await reader.read()
          if (done) break
          buffer += decoder.decode(value, { stream: true })

          const frames = buffer.split('\n\n')
          buffer = frames.pop()

          frames.forEach(frame => {
            const dataLine = frame.split('\n').find(line => line.startsWith('data:'))
            if (!dataLine) return
            const payload = JSON.parse(dataLine.slice(5).trim())
            if (onProgress) onProgress(payload)
            if (payload.event === 'error') {
              throw new Error(payload.message || 'Ошибка обработки')
            }
            if (payload.event === 'done') {
              result = payload
            }
          })
        }

        if (!result) {
          throw new Error('Сервер не вернул результат')
        }
        return result
      })
    },
    downloadPackResult(ctx, { id, filename }) {
      const token = localStorage.getItem('accessToken')
      const baseURL = (axios.defaults.baseURL || '').replace(/\/$/, '')

      return fetch(`${baseURL}/sigame/pack-from-files/${id}/download`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then(async response => {
        if (!response.ok) {
          throw new Error('Не удалось скачать файл')
        }
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename || 'pack.siq'
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    uploadFile(ctx, {file, type}) {
      const formData = new FormData()
      formData.append('file', file)
      if (type) formData.append('type', type)
      return new Promise((resolve, reject) => {
        axios
          .post('/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    inpaintingRemoveObject(ctx, {imageUrl, maskUrl, cancelToken}) {
      return new Promise((resolve, reject) => {
        axios
          .post('/inpainting/remove-object', {
            image_url: imageUrl,
            mask_url: maskUrl,
          }, {cancelToken})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    inpaintingRemoveObjectAsync(ctx, {imageUrl, maskUrl}) {
      return new Promise((resolve, reject) => {
        axios
          .post('/inpainting/remove-object-async', {
            image_url: imageUrl,
            mask_url: maskUrl,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    inpaintingStatus(ctx, {predictionId}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/inpainting/status/${predictionId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadArtistMembers(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/artist/${id}/load-members`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateArtistMembers(ctx, {id, currentMembers, formerMembers}) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/artist/${id}/members`, {
            current_members: currentMembers,
            former_members: formerMembers,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
